{
  "welcome": {
    "title": "Добро пожаловать, {{name}}",
    "title_noName": "Добро пожаловать в Rhemn",
    "body": "Всё, что светится, покажет, что оно делает. Изучайте в любом порядке, когда захотите.",
    "start": "Начать знакомство",
    "later": "Не сейчас"
  },
  "card": {
    "tryIt": "Попробовать",
    "takeALook": "Посмотреть",
    "pro": "Входит в Rhemn Pro",
    "close_aria": "Закрыть"
  },
  "pill": {
    "progress": "Изучено: {{count}} из {{total}}",
    "progress_short": "{{count}} из {{total}}",
    "done": "Готово",
    "done_aria": "Завершить знакомство",
    "complete": "Всё изучено"
  },
  "sr": {
    "started": "Режим знакомства включён. Кнопки сначала показывают, что они делают.",
    "hint": "Режим знакомства. Сначала показывает, что делает этот элемент.",
    "ended": "Режим знакомства выключен."
  },
  "settings": {
    "row": "Как устроен Rhemn",
    "row_sub": "Коротко о каждом разделе",
    "row_aria": "Как устроен Rhemn: изучить приложение снова",
    "helpCaption": "Справка"
  },
  "steps": {
    "intention": {
      "title": "Намерение дня",
      "body": "Запишите самое важное на сегодня и отметьте, когда будет сделано."
    },
    "now": {
      "title": "Ваш день по молитвам",
      "body": "Rhemn делит ваш день по молитвам. Здесь видно, сколько осталось до следующей и что вы запланировали на это время."
    },
    "verse": {
      "title": "Инсайты по аяту",
      "body": "Задайте вопрос о сегодняшнем аяте, прочтите краткий тафсир и найдите аяты на ту же тему."
    },
    "qibla": {
      "title": "Кибла",
      "body_chrome": "Направление на Каабу из вашего местоположения, в градусах от севера.",
      "body_ios": "Указывает на Каабу оттуда, где вы находитесь. Включите живой компас, и он будет поворачиваться вместе с вами."
    },
    "prayer": {
      "title": "Время молитв",
      "body_chrome": "Время пяти молитв на сегодня для вашего местоположения. Выберите метод расчёта, которому следует ваша мечеть.",
      "body_ios": "Следующая молитва с одного взгляда. Откройте, чтобы увидеть все пять времён и напоминание для каждой."
    },
    "tasks": {
      "title": "Задачи",
      "body": "Храните дела в списках и отведите каждому место между молитвами."
    },
    "notes": {
      "title": "Заметки",
      "body_chrome": "Пишите или просто говорите. Rhemn расшифровывает голосовые заметки и встречи, а затем кратко их излагает.",
      "body_ios": "Пишите или просто говорите. Rhemn превращает сказанное в аккуратные заметки с кратким итогом."
    },
    "profile": {
      "title_chrome": "Ваш профиль",
      "body_chrome": "Настройки аккаунта и конфиденциальности. Возвращайтесь сюда, чтобы снова изучить Rhemn.",
      "title_ios": "Ещё",
      "body_ios": "Сохранённые аяты, Кибла и настройки аккаунта. Отсюда можно снова изучить Rhemn."
    }
  }
}
